<template lang="html">
  <v-container class='fluid'>
    <v-layout align-center justify-center>
      <v-flex xs10>
        <v-card class="text-xs-center">

          <!-- Título da página -->
          <basic-toolbar :title="'Editar Órgão Financiador'"></basic-toolbar>

          <v-card-text>
            <v-form v-model="formularioValido" ref="form">
              <v-container>

              <!-- Nome -->
              <v-layout row>
                <v-flex xs12>
                  <v-text-field
                    label='Nome'
                    :value="orgaoFinanciadorProjetoPesquisa.nome === null || orgaoFinanciadorProjetoPesquisa.nome === '' ? '-' : orgaoFinanciadorProjetoPesquisa.nome"
                    readonly
                    >
                  </v-text-field>
                </v-flex>
              </v-layout>

              <!-- Sigla -->
              <v-layout row>
                <v-flex xs12>
                  <v-text-field
                    label='Sigla'
                    :value="orgaoFinanciadorProjetoPesquisa.sigla === null || orgaoFinanciadorProjetoPesquisa.sigla === '' ? '-' : orgaoFinanciadorProjetoPesquisa.sigla"
                    readonly
                    >
                  </v-text-field>
                </v-flex>
              </v-layout>

              <!-- Valor (R$) -->
              <v-layout row>
                <v-flex xs12>
                  <v-text-field-money
                    label="Valor (R$)*" 
                    v-model="orgaoFinanciadorProjetoPesquisa.valor" 
                    v-bind:properties="{
                      placeholder: ' ',
                      rules: obrigatorio
                    }"
                    v-bind:options="{
                      locale: 'pt-BR',
                      length: 13,
                      precision: 2,
                      empty: null,
                    }"
                  />      
                </v-flex>
              </v-layout>

              <br>

              </v-container>
            </v-form>

            <v-divider></v-divider>

            <v-card-actions>

              <!-- Botão "Cancelar" -->
              <v-btn color="primary" @click="cancelar()">Cancelar</v-btn>

              <v-spacer></v-spacer>

              <!-- Botão "Salvar" -->
              <v-btn color="primary" :disabled="!formularioValido" @click="editaOrgaoFinanciadorProjetoPesquisa()">Salvar</v-btn>

            </v-card-actions>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  import projetos from '@/utils/projetos'
  import BasicToolbar from '@/components/toolbars/basic-toolbar'
  import { mapActions } from 'vuex'

  export default {
    props: ['idProjetoPesquisa', 'idOrgaoFinanciadorProjetoPesquisa'],
    data: () => ({
      formularioValido: false,
      orgaoFinanciadorProjetoPesquisa: {},
      obrigatorio: [v => !!v || 'Este campo é obrigatório']
    }),
    methods: {
      ...mapActions('ui', ['SHOW_GLOBAL_LOADING', 'HIDE_GLOBAL_LOADING', 'SHOW_SNACKBAR']),

      // Edita o órgão financiador do projeto de pesquisa.
      editaOrgaoFinanciadorProjetoPesquisa: function () {
        this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Editando órgão financiador do projeto de pesquisa...' })
        projetos.putOrgaoFinanciadorProjetoPesquisa(this.idProjetoPesquisa, this.idOrgaoFinanciadorProjetoPesquisa, this.orgaoFinanciadorProjetoPesquisa)
        .then(response => {
          this.SHOW_SNACKBAR({snackbarType: 'success', snackbarText: response.body.mensagem})
          this.$router.push({name: 'ProjetoPesquisaOrgaosFinanciadores'})
        })
        .catch(error => {
          this.SHOW_SNACKBAR({snackbarType: 'error', snackbarText: error.body.mensagem})
        })
        .finally(() => {
          this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Editando órgão financiador do projeto de pesquisa...' })
        })
      },

      // Redireciona para a página anterior.
      cancelar: function () {
        this.$router.go(-1)
      }
    },
    mounted () {
      // Carrega o órgão financiador do projeto de pesquisa.
      this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando órgão financiador do projeto de pesquisa...' })
      projetos.getOrgaoFinanciadorProjetoPesquisa(this.idProjetoPesquisa, this.idOrgaoFinanciadorProjetoPesquisa)
      .then(response => {
        this.orgaoFinanciadorProjetoPesquisa = response.data
      })
      .catch(error => {
        console.log('Erro ao mandar o request' + error)
      })
      .finally(() => {
        this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando órgão financiador do projeto de pesquisa...' })
      })
    },
    components: {
      'basic-toolbar': BasicToolbar
    }
  }
</script>

<style lang="css">
  .menu {
    display: block !important;
  }

  .no-resize div textarea{
    resize: none;
  }
  .input-group__icon-cb {
    cursor: pointer !important;
  }
</style>



// WEBPACK FOOTER //
// editar-orgao-financiador.vue?63667200